import { effects } from 'redux-saga'

import waitForHmac from '../authentication/wait'

export default function* callWithHmac(func, ...args) {
  if (!func) {
    throw new Error('func is not defined')
  }

  const hmac = yield effects.call(waitForHmac)

  return yield effects.call(func, hmac, ...args)
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/effects/callWithHmac.js